(function( $, moment ) {
    "use strict";

    var STORAGE_KEY = 'app_booking_calendar';
    var CALENDAR_ASYNC_TIMEOUT = 600;
    var Event = require('./_events.js');
    var Tooltip = require('./_tooltip.js');
    var BookingCalendarEvent = new Event();
    window.CalendarTooltip = new Tooltip();

    var BookingCalendar = {
        data: null,

        setData: function(data) {
            BookingCalendar.data = data || {};

            if (! BookingCalendar.data.eventSources) {
                BookingCalendar.data.eventSources = [];
            }

            if (! BookingCalendar.data.events) {
                BookingCalendar.data.events = [];
            }

            $.each(BookingCalendar.data.eventSources, function() {
                BookingCalendar.data.events = BookingCalendar.data.events.concat(this.events);
            });

            BookingCalendar.data.days = {};

            $.each(BookingCalendar.data.events, function() {
                var startDate = moment(this.start),
                    currentDate = startDate.clone(),
                    registered = false;

                while (currentDate.isBefore(this.end) || (! registered && currentDate.isSame(this.end))) {
                    var dayKey = currentDate.format('YYYY-MM-DD');

                    if (! BookingCalendar.data.days[dayKey]) {
                        BookingCalendar.data.days[dayKey] = [];
                    }

                    BookingCalendar.data.days[dayKey].push(this);

                    registered = true;
                    currentDate.add(1, 'day').startOf('day');
                }
            });
        },

        updateCalendarListPosition: function($calendarListsForm) {
            var $position = 0,
                $calendarListEntries = $calendarListsForm.find('[data-form-entry="calendarlist"]');

            $calendarListEntries.each(function () {
                var $calendarListEntry = $(this),
                    $positionInput = $calendarListEntry.find('[data-form-control="position"]')
                ;

                if (!$positionInput.length) {
                    return;
                }

                $positionInput.val($position++);
            });
        },

        onRefreshLayout: function() {
            var $calendarLayout = $(this),
                $calendarDatepicker = $calendarLayout.find('[booking-calendar-datepicker]');

            $calendarDatepicker.trigger('refresh.bc.datepicker');
        },

        onRefreshDatepicker: function() {
            var $calendarDatepicker = $(this),
                $calendarLayout = $calendarDatepicker.closest('[booking-calendar-layout]'),
                $calendar = $calendarLayout.find('[booking-calendar-calendar]');

            $calendarDatepicker.data('booking.calendar.datepicker.refresh', true);

            // Can be improved...
            // Refresh datepicker days without change the current viewDate and viewMode

            $calendarDatepicker.datepicker('setDate', $calendar.fullCalendar('getDate').toDate());
        },

        onRefreshCalendar: function() {
            var $calendar = $(this),
                refreshTimeout = $calendar.data('booking-calendar.rendered') ? CALENDAR_ASYNC_TIMEOUT : 0;

            $calendar.data('booking-calendar.rendered', true);

            clearTimeout($calendar.data('booking-calendar.refresh.timeout'));

            $calendar.data('booking-calendar.refresh.timeout', setTimeout(function () {
                var $calendarLayout = $calendar.closest('[booking-calendar-layout]'),
                    $calendarListsForm = $calendarLayout.find('[data-form="calendarlists"]'),
                    $calendarListEntries = $calendarListsForm.find('[data-form-entry="calendarlist"]'),
                    $presenterListsForm = $calendarLayout.find('[data-form="presenterlists"]'),
                    $presenterListEntries = $presenterListsForm.find('[data-form-entry="presenterlist"]'),
                    $undefinedPresenterInput = $presenterListsForm.find('[data-form-control="undefined_presenter"]'),
                    $anyPresenterInput = $presenterListsForm.find('[data-form-control="any_presenter"]'),
                    $bookingTypesForm = $calendarLayout.find('[data-form="calendarview-booking-types"]'),
                    $bookingTypeInputs = $bookingTypesForm.find('[data-form-control="booking_type"]'),
                    view = $calendar.fullCalendar('getView'),
                    calendarData = [],
                    calendarIds = [],
                    presenterIds = [],
                    bookingTypes = [];

                if (window.storageAvailable('sessionStorage')) {
                    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
                        date: $calendar.fullCalendar('getDate').format(),
                        view: view.type
                    }));
                }

                // Calendar Ids
                $calendarListEntries.each(function() {
                    var $calendarListEntry = $(this),
                        $selectedInput = $calendarListEntry.find('[data-form-control="selected"]'),
                        $calendarInput = $calendarListEntry.find('[data-form-control="calendar"]');

                    if ($selectedInput.prop('checked')) {
                        calendarIds.push($calendarInput.val());
                    }
                });

                if ($calendar.data('push-calendars')) {
                    calendarIds = calendarIds.concat($calendar.data('push-calendars'));

                    $calendar.data('push-calendars', null)
                }

                if (calendarIds.length === 0) {
                    $calendar.fullCalendar('removeEventSources');

                    BookingCalendar.setData(null);

                    $calendarLayout.trigger('refresh.bc.layout');

                    return;
                }

                calendarData.push({name:'calendars', value:calendarIds.join('-')});

                // Presenter Ids
                if ($undefinedPresenterInput.prop('checked')) {
                    presenterIds.push('undefined');
                }

                if ($anyPresenterInput.prop('checked')) {
                    presenterIds.push('any');
                } else {
                    $presenterListEntries.each(function() {
                        var $presenterListEntry = $(this),
                            $selectedInput = $presenterListEntry.find('[data-form-control="selected"]'),
                            $presenterInput = $presenterListEntry.find('[data-form-control="presenter"]');

                        if ($selectedInput.prop('checked')) {
                            presenterIds.push($presenterInput.val());
                        }
                    });

                    if ($calendar.data('push-presenters')) {
                        presenterIds = presenterIds.concat($calendar.data('push-presenters'));

                        $calendar.data('push-presenters', null)
                    }
                }

                if (presenterIds.length > 0) {
                    calendarData.push({name:'presenters', value:presenterIds.join('-')});
                } else /* if ($presenterListEntries.children().first().length > 0) */ {
                    $calendar.fullCalendar('removeEventSources');

                    BookingCalendar.setData(null);

                    $calendarLayout.trigger('refresh.bc.layout');

                    return;
                }

                // Booking Types
                $bookingTypeInputs.filter(':checked').each(function() {
                    bookingTypes.push($(this).val());
                });

                if (bookingTypes.length === 0) {
                    $calendar.fullCalendar('removeEventSources');

                    return;
                }

                calendarData.push({name:'booking_types', value:bookingTypes.join('-')});

                // View Period
                var start = view.start.clone();

                if ('month' === view.type) {
                    start.subtract(1, 'days');  // fullcalendar starts on monday; bootstrap calendar starts on previous sunday
                } else {
                    start.subtract(1, 'month').endOf('month').startOf('isoweek').subtract(1, 'day');    // last sunday of last month
                }

                var end = start.clone().add(42, 'days');    // 6 weeks calendar

                calendarData.push({name: 'start', value: start.toISOString()});

                calendarData.push({name: 'end', value: end.toISOString()});

                $calendar.addClass('ajax-loading');

                // Feed Request
                $.App.api('GET', 'calendar-view/event-sources', calendarData)
                    .done(function(response) {
                        if (! response.success) {
                            // console.log('done error');
                            return;
                        }

                        $calendar.fullCalendar('removeEventSources');

                        $.each(response.eventSources, function() {
                            $calendar.fullCalendar('addEventSource', this);
                        });

                        if (response.eventSources.length > 1) {
                            $calendar.addClass('has-multiple-agendas');
                        } else {
                            $calendar.removeClass('has-multiple-agendas');
                        }

                        // Something is really slow here
                        BookingCalendar.setData({
                            start: start,
                            end: end,
                            eventSources: response.eventSources
                        });

                        $calendarLayout.trigger('refresh.bc.layout');
                    })
                    .always(function() {
                        $calendar.removeClass('ajax-loading');
                    });
            }, refreshTimeout));
        },

        onRefreshSearch: function() {
            var $calendarResult = $(this),
                $calendarLayout = $calendarResult.closest('[booking-calendar-layout]'),
                $calendarSearchForm = $calendarLayout.find('[data-form="calendar-search"]');

            $calendarSearchForm.trigger('submit');
        },

        onRenderEvent: function(ev, event, element, view)
        {
            BookingCalendarEvent.render(event, element, view);
        },

        onSelectEvent: function(ev, event, jsEvent, view)
        {
            window.CalendarTooltip.render(event, $(this), jsEvent);
        },

        onChangeCalendarLists: function(ev) {
            ev.preventDefault();

            $(this).trigger('submit');
        },

        onMovedCalendarList: function (evt) {
            var $calendarListsForm = $(evt.item).parents('[data-form="calendarlists"]:first');

            $calendarListsForm.trigger('change');
        },

        onSubmitCalendarLists: function(ev) {
            ev.preventDefault();

            var $calendarListsForm = $(this),
                $calendarListInputs = $calendarListsForm.find(':input[name^="calendar_lists["]'),
                $calendarLayout = $calendarListsForm.closest('[booking-calendar-layout]'),
                $calendarLists = $calendarLayout.find('[booking-calendar-calendarlists]'),
                $calendarResult = $calendarLayout.find('[booking-calendar-result]'),
                $calendar = $calendarLayout.find('[booking-calendar-calendar]'),
                timeout = $calendar.length ? CALENDAR_ASYNC_TIMEOUT : 0
            ;

            BookingCalendar.updateCalendarListPosition($calendarListsForm);

            var formData = $calendarListInputs.serialize();

            $calendar.trigger('refresh.bc.calendar');
            $calendarResult.trigger('refresh.bc.search');

            clearTimeout($calendar.data('booking-calendar.submit-calendarlists.timeout'));
            $calendar.data('booking-calendar.submit-calendarlists.timeout', setTimeout(function () {

                $calendarListsForm.addClass('ajax-loading');
                // $calendarListInputs.prop('disabled', true);

                $.App.api('PUT', 'calendar-view/calendarlists', formData)
                    // .done(function (response) {
                    //     if (response.success) {
                    //         $calendarLists.html(response.html);
                    //         $calendarLists.app();
                    //     }
                    // })
                    .always(function () {
                        $calendarListsForm.removeClass('ajax-loading');
                        $calendarListInputs.prop('disabled', false);
                    });
            }, timeout));
        },

        onDeleteCalendarList: function(ev) {
            ev.preventDefault();

            var $button = $(this),
                $formEntry = $button.closest('[data-form-entry="calendarlist"]'),
                $bookingCalendarCalendarLists = $formEntry.closest('[booking-calendar-calendarlists]'),
                $select = $formEntry.find('[data-form-control="calendar"]'),
                $newCalendarListSelect = $('#calendar_list_calendar'),
                $newCalendarListField = $bookingCalendarCalendarLists.find('[data-form-target-container="new-calendarlist-field"]'),
                $name = $formEntry.find('.entity .signature__name'),
                optionValue = $select.val(),
                optionText = $name.text();

            $newCalendarListSelect.data('selectize').addOption({value: optionValue, text: optionText});

            $newCalendarListField.removeClass('hidden');
        },

        onSubmitNewCalendarList: function(ev) {
            ev.preventDefault();

            var $newCalendarListForm = $(this),
                $calendarLayout = $newCalendarListForm.closest('[booking-calendar-layout]'),
                $calendarLists = $calendarLayout.find('[booking-calendar-calendarlists]'),
                $calendarResult = $calendarLayout.find('[booking-calendar-result]'),
                $calendar = $calendarLayout.find('[booking-calendar-calendar]'),
                formData = $newCalendarListForm.find(':input[name^="calendar_list["]').serialize(),
                newCalendarId = $newCalendarListForm.find(':input[name="calendar_list[calendar]"]').val();

            $calendar.data('push-calendars', [newCalendarId]);

            $calendar.trigger('refresh.bc.calendar');
            $calendarResult.trigger('refresh.bc.search');

            $newCalendarListForm.addClass('ajax-loading');
            $.App.api('POST', 'calendar-view/calendarlists', formData)
                .done(function(response) {
                    if (response.success) {
                        $calendarLists.html(response.html);
                        $calendarLists.app();
                    }
                })
                .always(function() {
                    $newCalendarListForm.removeClass('ajax-loading');
                });
        },

        onChangePresenterLists: function(ev) {
            ev.preventDefault();

            $(this).trigger('submit');
        },

        onSubmitPresenterLists: function(ev) {
            ev.preventDefault();

            var $presenterListsForm = $(this),
                $presenterListInputs = $presenterListsForm.find(':input[name^="presenter_lists["]'),
                $calendarLayout = $presenterListsForm.closest('[booking-calendar-layout]'),
                $presenterLists = $calendarLayout.find('[booking-calendar-presenterlists]'),
                $calendarResult = $calendarLayout.find('[booking-calendar-result]'),
                $calendar = $calendarLayout.find('[booking-calendar-calendar]'),
                timeout = $calendar.length ? CALENDAR_ASYNC_TIMEOUT : 0,
                formData = $presenterListInputs.serialize();

            $calendar.trigger('refresh.bc.calendar');
            $calendarResult.trigger('refresh.bc.search');

            clearTimeout($calendar.data('booking-calendar.submit-presenterlists.timeout'));
            $calendar.data('booking-calendar.submit-presenterlists.timeout', setTimeout(function () {
                $presenterListsForm.addClass('ajax-loading');
                $presenterListInputs.prop('disabled', true);

                $.App.api('PUT', 'calendar-view/presenterlists', formData)
                    .done(function(response) {
                        if (response.success) {
                            $presenterLists.html(response.html);
                            $presenterLists.app();
                        }
                    })
                    .always(function() {
                        $presenterListsForm.removeClass('ajax-loading');
                        $presenterListInputs.prop('disabled', false);
                    });
            }, timeout));
        },

        onSubmitNewPresenterList: function(ev) {
            ev.preventDefault();

            var $newPresenterListForm = $(this),
                $calendarLayout = $newPresenterListForm.closest('[booking-calendar-layout]'),
                $presenterLists = $calendarLayout.find('[booking-calendar-presenterlists]'),
                $presenterListsForm = $presenterLists.find('[data-form="presenterlists"]'),
                // $anyPresenterInput = $presenterListsForm.find('[data-form-control="any_presenter"]'),
                $calendarResult = $calendarLayout.find('[booking-calendar-result]'),
                $calendar = $calendarLayout.find('[booking-calendar-calendar]'),
                formData = $newPresenterListForm.find(':input[name^="presenter_list["]').serialize(),
                newPresenterId = $newPresenterListForm.find(':input[name="presenter_list[presenter]"]').val();

            // $anyPresenterInput.prop('checked', false);

            $calendar.data('push-presenters', [newPresenterId]);

            $calendar.trigger('refresh.bc.calendar');
            $calendarResult.trigger('refresh.bc.search');

            $newPresenterListForm.addClass('ajax-loading');

            $.App.api('POST', 'calendar-view/presenterlists', formData)
                .done(function(response) {
                    if (response.success) {
                        $presenterLists.html(response.html);
                        $presenterLists.app();
                    }
                })
                .always(function() {
                    $newPresenterListForm.removeClass('ajax-loading');
                });
        },

        onChangeBookingTypes: function(ev) {
            ev.preventDefault();

            var $form = $(this),
                $bookingTypeInputs = $form.find('[data-form-control="booking_type"]');

            if ($bookingTypeInputs.filter(':checked').length === 0) {
                $(ev.target).prop('checked', true);

                return;
            }

            $form.trigger('submit');
        },

        onSubmitBookingTypes: function(ev) {
            ev.preventDefault();

            var $form = $(this),
                $bookingTypeInputs = $form.find('[data-form-control="booking_type"]'),
                $calendarLayout = $form.closest('[booking-calendar-layout]'),
                $calendarResult = $calendarLayout.find('[booking-calendar-result]'),
                $calendar = $calendarLayout.find('[booking-calendar-calendar]'),
                formData = $bookingTypeInputs.serialize();

            $calendar.trigger('refresh.bc.calendar');
            $calendarResult.trigger('refresh.bc.search');


            clearTimeout($calendar.data('booking-calendar.submit-bookingtypes.timeout'));
            $calendar.data('booking-calendar.submit-bookingtypes.timeout', setTimeout(function () {
                // $bookingTypeInputs.prop('disabled', true);
                $form.addClass('ajax-loading');

                $.App.api('PUT', 'calendar-view', formData)
                    .always(function() {
                        $form.removeClass('ajax-loading');
                        $bookingTypeInputs.prop('disabled', false);
                    });
            }, CALENDAR_ASYNC_TIMEOUT));
        }
    };

    $('body').on('app.init', function(ev) {
        var $container = $(ev.container),
            $calendarLayout = $container.find('[booking-calendar-layout]'),
            $calendarDatepicker = $container.find('[booking-calendar-datepicker]'),
            $calendar = $container.find('[booking-calendar-calendar]'),
            $calendarResult = $container.find('[booking-calendar-result]'),
            $calendarListsForm = $container.find('[data-form="calendarlists"]'),
            $newCalendarListForm = $container.find('[data-form="new-calendarlist"]'),
            $presenterListsForm = $container.find('[data-form="presenterlists"]'),
            $newPresenterListForm = $container.find('[data-form="new-presenterlist"]'),
            $bookingTypesForm = $container.find('[data-form="calendarview-booking-types"]');

        $calendarLayout.on('refresh.bc.layout', BookingCalendar.onRefreshLayout);
        $calendarDatepicker.on('refresh.bc.datepicker', BookingCalendar.onRefreshDatepicker);
        $calendar
            .on('refresh.bc.calendar', BookingCalendar.onRefreshCalendar)
            .on('render.bc.event', BookingCalendar.onRenderEvent)
            .on('select.bc.event', BookingCalendar.onSelectEvent);

        $calendarResult.on('refresh.bc.search', BookingCalendar.onRefreshSearch);

        $calendarListsForm
            .on('change', BookingCalendar.onChangeCalendarLists)
            .on('submit', BookingCalendar.onSubmitCalendarLists);

        $calendarListsForm.find('[data-form-delete-entry]')
            .on('click', BookingCalendar.onDeleteCalendarList);

        $newCalendarListForm
            .on('change', BookingCalendar.onChangeCalendarLists)
            .on('submit', BookingCalendar.onSubmitNewCalendarList);

        $presenterListsForm
            .on('change', BookingCalendar.onChangePresenterLists)
            .on('submit', BookingCalendar.onSubmitPresenterLists);

        $newPresenterListForm
            .on('change', BookingCalendar.onChangePresenterLists)
            .on('submit', BookingCalendar.onSubmitNewPresenterList);

        $bookingTypesForm
            .on('change', BookingCalendar.onChangeBookingTypes)
            .on('submit', BookingCalendar.onSubmitBookingTypes);

        $calendarListsForm.find('[data-form-entries=calendarlist]').sortable({
            handle: '.drag-handle',
            onEnd: BookingCalendar.onMovedCalendarList
        });

        var sessionData = {};
        if (window.storageAvailable('sessionStorage') && sessionStorage.getItem(STORAGE_KEY)) {
            sessionData = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
        }

        var date = sessionData.date ? moment(sessionData.date) : moment();

        $calendarDatepicker.datepicker({
            language: "fr",
            weekStart: 7,
            todayHighlight: true,
            updateViewDate: false,
            maxViewMode: 'years',
            defaultViewDate: {
                day: date.day(),
                month: date.month(),
                year: date.year()
            },

            beforeShowDay: function(date) {
                if (! BookingCalendar.data || ! BookingCalendar.data.days) {
                    return;
                }

                var dayKey = moment(date).format('YYYY-MM-DD'),
                    classes = [];

                if ($calendar.children().length > 0 &&
                    dayKey === $calendar.fullCalendar('getDate').format('YYYY-MM-DD')
                ) {
                    classes.push('active');
                }

                if (BookingCalendar.data.days[dayKey]) {
                    classes.push('ui-state-pc-event');
                }

                if (classes.length) {
                    return {classes: classes.join(' ')};
                }
            }
        }).on('changeDate', function(ev) {
            if ($calendarDatepicker.data('booking.calendar.datepicker.refresh')) {
                $calendarDatepicker.data('booking.calendar.datepicker.refresh', null);

                return;
            }

            var $layout = $(this).closest('[booking-calendar-layout]'),
                $result = $layout.find('[booking-calendar-result]'),
                momentDate = moment(ev.date);

            if ($calendar.length) {
                $calendar.fullCalendar('gotoDate', momentDate);

                return;
            }

            var $target = $result.find('[data-date="'+momentDate.format('YYYY-MM-DD')+'"]');

            if ($target.length) {
                $target.focus();

                $('html, body').animate({scrollTop: $target.offset().top - 10}, 500);
            }
        }).on('changeMonth', function(ev) {
            $calendarDatepicker.data(
                'booking-calendar.datepicker.view.month',
                new Date(ev.date).getMonth() + 1
            );
        }).on('changeYear', function(ev) {
            $calendarDatepicker.data(
                'booking-calendar.datepicker.view.year',
                String(ev.date).split(" ")[3]
            );
        });

        var options = {
            height: window.innerHeight > 750 ? (window.innerHeight - 220) : 750,
            aspectRatio: 2,
            header: {
                left: 'today,prev,next',
                center: 'title',
                right: 'month,agendaWeek,agendaThreeDay,agendaDay,listWeek'
            },
            navLinks: true,
            editable: false,
            eventLimit: 3,
            scrollTime: '10:00',
            firstDay: 1,
            titleFormat: 'DD MMMM YYYY',
            slotLabelFormat: 'h(:mm)a',
            listDayFormat: 'dddd DD MMMM YYYY',
            listDayAltFormat: '',
            displayEventTime: false,
            defaultTimedEventDuration: '00:30:00',
            defaultDate : date,
            defaultView : sessionData.view ? sessionData.view : 'month',
            views: {
                agendaThreeDay: {
                    type: 'agenda',
                    duration: { days: 3 },
                    buttonText: '3 jours'
                }
            },
            viewRender : function() {
                $calendar.trigger('refresh.bc.calendar');
            },
            eventRender: function(event, element, view) {
                $calendar.trigger('render.bc.event', [event, element, view]);
            },
            eventClick: function (event, jsEvent, view) {
                $calendar.trigger('select.bc.event', [event, jsEvent, view]);
            },
            dayClick: function(date, jsEvent, view, resourceObj) {
                if ($calendar.data('booking-can-create')) {
                    clearTimeout($calendar.data('booking-calendar.add-booking.timeout'));

                    if ($calendar.data('booking-calendar.add-booking.date')
                        && $calendar.data('booking-calendar.add-booking.date').format() === date.format()
                    ) {
                        window.location.assign([
                            $calendar.data('booking-add-url'),
                            'start-date=' + $calendar.data('booking-calendar.add-booking.date').toISOString()
                        ].join('?'));
                    }
                }

                $calendar.fullCalendar('select', date);
                $calendar.data('booking-calendar.add-booking.date', date);

                var $target = $(jsEvent.target),
                    $row = $target.closest('.fc-row'),
                    $highlightElements = $row.find('> .fc-highlight-skeleton .fc-highlight');

                $highlightElements.addClass('booking-creatable');

                if ($calendar.data('booking-can-create')) {
                    $calendar.data('booking-calendar.add-booking.timeout', setTimeout(function () {
                        $calendar.fullCalendar('unselect');
                        $calendar.data('booking-calendar.add-booking.date', null);
                    }, 450));
                }
            }
        };

        if (matchMedia('screen and (max-width: 768px)').matches) {
            options.header.right = 'month,listWeek,agendaDay';
            options.defaultView = 'month';
        }

        $calendar.fullCalendar(options);
    });

}( require('jquery'), require('moment'), require('fullcalendar'), require('jquery-sortablejs') ));
